<script lang="ts">
	import type { AddressData, TermData } from "@hitit/api";
	import { OBJECT_PURPOSE_STORE_REGISTRATION } from "@hitit/api";
	//component
	import SearchAddress from "../components/createStore/SearchAddress.svelte";
	import Registration from "../components/createStore/Registration.svelte";
	import Term from "../components/createStore/Term.svelte";
	import CreateStoreLayout from "../layouts/CreateStoreLayout.svelte";
	//img
	import axios from "axios";
	import BackIMG from "../assets/create_store/back.png";
	//split
	import {
		StepProgressBar,
		FormInputComposite,
		DisplayTextButton,
		InputFrame,
		OutlineButton,
		DefaultButton,
		DefaultSelect,
		DefaultTextInput,
		FormSlotComposite,
		Welcome,
	} from "@hitit/new_ui/src";
	import { t, api } from "../stores";
	import { accessControlList, storeIds } from "../v7/store";
	import { navigate } from "svelte-routing";
	import { logout } from "../functions/auth/logout";
	import { onlyNumberHandler } from "../v7/utils";

	export let loadedNoStroe = false;
	const BASE_URL = "HITIT_BACKEND_URL";

	let success = false;
	let awaitLoadstore = false;

	enum Phase {
		basicInfomation,
		address,
		registration,
		term,
		done,
	}

	let phase: Phase = Phase.basicInfomation;

	let detailAddressFocus = false;

	//Inputs
	let storeName = "";
	let storeCall = "";
	let storeAddress = "";
	let storeDetailAddress = "";
	let storeCategory1: string = "";
	let storeCategory2: string = "";
	let typeCodes: { type1: string; type2: string; id: string }[] = [];

	$: basicInfoButtonDisabled =
		storeName === "" ||
		storeCall === "" ||
		storeAddress === "" ||
		storeDetailAddress === "" ||
		storeCategory1 === "" ||
		storeCategory2 === "";

	$: type1list = Object.keys(
		typeCodes.reduce((acc, v) => {
			acc[v.type1] = true;
			return acc;
		}, {} as Record<string, boolean>)
	).map((v) => ({ value: v, label: v }));

	$: type2list = typeCodes
		.filter((v) => v.type1 === storeCategory1)
		.map((v) => ({ value: v.id, label: v.type2, display: v.type2 }));

	async function loadCategories() {
		const r = await $api.getStoreTypeCode();
		typeCodes = r.data.result;
	}
	// address
	let address: AddressData | undefined;

	function setAddress(addDTO: AddressData) {
		address = addDTO;
		storeAddress = addDTO.formattedAddress1 || addDTO.formattedAddress2;
		phase = Phase.basicInfomation;
	}

	// Register
	let registerErrorMessage = "";
	let registrationNumb = "";
	let registrationFile: File | null = null;

	function skipButtonHandler() {
		registrationFile = null;
		registrationNumb = "";

		phase = Phase.term;
	}

	function setRegistrationNumb() {
		const pattern = /([0-9]{3})([0-9]{2})([0-9]{5})/;

		if (!pattern.test(registrationNumb)) {
			registerErrorMessage = $t("hub.store.ko_registration.format_not_match");
			return;
		}

		phase = Phase.term;
	}

	//term
	let articles = "";
	let termAgree = false;
	function TAC_Order(key: string) {
		switch (key) {
			case "힛잇 이용약관":
				return 0;
			case "전자금융거래이용약관":
				return 1;
			case "개인정보 수집 및 이용":
				return 2;
			case "개인정보 제공":
				return 3;
			default:
				return 4;
		}
	}
	async function loadTAC(count = 3) {
		try {
			const { data } = await $api.getTermsAndConditions("USER");
			const terms = data as TermData["termsAndConditionArticles"][];
			const __articles = terms
				.sort((a, b) => TAC_Order(a.name || "") - TAC_Order(b.name || ""))
				.reduce((prev, cur) => {
					const __article = cur.articles.reduce(
						(prev, cur) => prev + cur.content,
						""
					);
					return prev + __article;
				}, "")
				.replaceAll("\n", "</br>");

			articles = __articles;
		} catch {
			if (count === 0) {
				alert($t("sso.error.unknownError"));
				location.assign("/");
				return;
			}
			loadTAC(count - 1);
		}
	}

	//submit

	let submitting = false;

	async function submit() {
		try {
			submitting = true;

			let fileLink = "";

			if (registrationFile !== null) {
				const isJpg = /.jpg/.test(registrationFile.name.toLowerCase());
				const isPng = /.png$/.test(registrationFile.name.toLowerCase());
				const isJpeg = /.jpeg$/.test(registrationFile.name.toLowerCase());

				const r = await $api.getFileUploadUrl({
					fileName:
						"registrationImage." + isPng ? "png" : isJpg || isJpeg ? "jpg" : "",
					fileType: isPng ? "PNG" : isJpg || isJpeg ? "JPG" : "",
					objectPurpose: OBJECT_PURPOSE_STORE_REGISTRATION,
				});

				//파일 업로드이기 떄문에, 정상적으로 처리되는 경우 네트워크 상황에 따라서 느릴 수 있다.
				//만약 제대로 업로드가 되지 않았다면, 추후 업로드 가능하기 때문에 경고만 발생시킨다.

				axios.put(r.data.url, registrationFile).catch(() => {
					alert("hub.create_store.error.registration_file_upload_failed");
				});

				fileLink = r.data.id;
			}
			const registerResponse = await $api.registerStoreKR({
				name: storeName,
				addressKR: {
					...(address as AddressData),
					roadAddress: address?.formattedAddress1,
					jibunAddress: address?.formattedAddress2,
					englishAddress: address?.formattedAddressEng || undefined,
					detailAddress: storeDetailAddress,
				},
				storeTypeCodeId: storeCategory2,
				lang: "ko",
				registrationNumber: registrationNumb.replace(/[^0-9]/g, ""),
				registrationNumberFileLink: fileLink,
				phonenumber: storeCall,
				phonenumberCountryCode: "82", //KR이기 때문에 82고정
			});
			//
			const uuid = registerResponse.data.storeUUID;
			//
			//
			$storeIds = uuid;
			success = true;
		} catch (e) {
			alert($t("sso.error.unknownError"));
			console.log(e);
		} finally {
			submitting = false;
		}
	}

	function storeCallHandler(e: Event) {
		const target = e.target as HTMLInputElement;
		onlyNumberHandler(target, (_, value) => {
			storeCall = value;
		});
	}

	async function successButtonHandler() {
		try {
			awaitLoadstore = true;
			await accessControlList.updateAccessControl();
			navigate("/");
		} catch (error) {
			console.log(error);
		} finally {
			awaitLoadstore = false;
		}
	}

	//Do
	loadCategories();
	loadTAC();

</script>

<main id="createstore">
	{#if success}
		<div class="welcome-container">
			<div class="welcome-box">
				<Welcome />
				<strong class="welcome-message">
					{$t('hub.create_store.complete_store_registration')}
				</strong>
				<p class="description">
					<span>{$t('hub.create_store.registration_procedure_complete')}</span>
					<span>{$t('hub.create_store.send_email_24hour')}</span>
				</p>
				<empty />
				<div class="button-wrapper">
					<DefaultButton
						on:click={successButtonHandler}
						isLoading={awaitLoadstore}>
						<span class="white">{$t('global.ok')}</span>
					</DefaultButton>
				</div>
			</div>
		</div>
	{:else}
		<CreateStoreLayout>
			{#if phase !== Phase.address}
				<div class="progress-wrapper">
					<div class="progrss">
						<StepProgressBar stepLength={4} stepNow={phase} />
					</div>
				</div>
			{/if}
			{#if phase === Phase.basicInfomation}
				<div class="basicInfomation">
					<FormInputComposite
						outerClassname={'createstore-composite'}
						labelFor={'storename'}
						bind:value={storeName}
						clearButtonCallback={() => (storeName = '')}
						placeholder={$t('hub.store.storeinfo.placeholder.name')}
						inputName={$t('hub.store.storeinfo.store_name')} />
					<FormInputComposite
						outerClassname={'createstore-composite'}
						labelFor={'storecall'}
						on:input={storeCallHandler}
						value={storeCall}
						clearButtonCallback={() => (storeCall = '')}
						placeholder={$t('hub.store.storeinfo.placeholder.it_will_show_on_place')}
						inputName={$t('hub.store.storeinfo.phonenumber')} />
					<FormSlotComposite
						outerClassname={'createstore-composite'}
						focus={detailAddressFocus}
						labelFor={'detailaddress'}
						inputName={$t('hub.store.storeinfo.store_address')}>
						<DisplayTextButton
							displayText={storeAddress}
							on:click={() => (phase = Phase.address)}
							placeholder={$t('hub.store.storeinfo.placeholder.address')} />
						<DefaultTextInput
							id={'detailaddress'}
							on:focus={() => (detailAddressFocus = true)}
							on:blur={() => (detailAddressFocus = false)}
							bind:value={storeDetailAddress}
							clearButtonDisplay={storeDetailAddress !== ''}
							clearCallback={() => (storeDetailAddress = '')}
							placeholder={$t('hub.store.storeinfo.placeholder.detail_address')} />
					</FormSlotComposite>
					<FormSlotComposite
						outerClassname={'createstore-composite'}
						inputName={$t('hub.store.storeinfo.store_category')}>
						<div class="store-category inputFrame">
							<DefaultSelect
								on:change={() => (storeCategory2 = '')}
								defaultClassName={'storecategory'}
								bind:value={storeCategory1}
								items={type1list}
								svg
								placeholder={$t('hub.store.storeinfo.placeholder.category1')} />
							<DefaultSelect
								defaultClassName={'storecategory'}
								bind:value={storeCategory2}
								items={type2list}
								svg
								placeholder={$t('hub.store.storeinfo.placeholder.category2')} />
						</div>
					</FormSlotComposite>
					<empty />
					<InputFrame>
						<div class="cancel-box">
							<OutlineButton
								on:click={() => (loadedNoStroe ? logout(`${BASE_URL}logout`) : navigate('/'))}>
								<span class="white"> {$t('global.cancel')} </span>
							</OutlineButton>
						</div>
						<div class="next-box">
							<DefaultButton
								disabled={basicInfoButtonDisabled}
								on:click={() => (phase = Phase.registration)}>
								<span class="white" class:disabled={basicInfoButtonDisabled}>
									{$t('global.next')}
								</span>
							</DefaultButton>
						</div>
					</InputFrame>
				</div>
			{:else if phase === Phase.address}
				<img
					on:click={() => (phase = Phase.basicInfomation)}
					id={'search-add-back'}
					src={BackIMG}
					alt="back to basic infomation" />
				<SearchAddress clickCallback={setAddress} />
			{:else if phase === Phase.registration}
				<Registration
					bind:errorMessage={registerErrorMessage}
					bind:registrationNumb
					bind:registrationFile />
				<div class="button-input-frame">
					<div class="next">
						<DefaultButton
							on:click={setRegistrationNumb}
							disabled={registrationNumb === '' || registrationFile === null}>
							<span
								class:white={registrationNumb !== '' || registrationFile !== null}>
								{$t('global.next')}
							</span>
						</DefaultButton>
					</div>
					<div class="skip">
						<OutlineButton on:click={skipButtonHandler} let:hovering={hover}>
							<span class:hover>SKIP</span>
						</OutlineButton>
					</div>
				</div>
			{:else if phase === Phase.term}
				<Term articles={articles} bind:checked={termAgree}>
					<DefaultButton
						isLoading={submitting}
						on:click={() => {
							submit();
						}}
						disabled={!termAgree || submitting}>
						<span class="term-button" class:white={termAgree}>
							{$t('global.next')}
						</span>
					</DefaultButton>
				</Term>
			{/if}
		</CreateStoreLayout>
	{/if}
</main>

<style lang="scss">
	@import "../variables.scss";

	/* basic infomation */
	/* Mobile First */
	main {
		width: 100%;
		min-height: 100vh;
		box-sizing: border-box;
		background-color: var(--background-1);
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		.progress-wrapper {
			display: flex;
			justify-content: center;
			.progrss {
				width: 212.8px;
				margin-bottom: 30px;
			}
		}

		span {
			transition: color 0.15s;
			font-size: 1.25rem;

			&.white {
				color: white;

				&.disabled {
					color: var(--default-disabled-btn-2);
				}
			}
		}

		.basicInfomation {
			display: flex;
			flex-direction: column;
			gap: 20.5px;

			.cancel-box {
				flex-grow: 110;
			}
			.next-box {
				flex-grow: 150;
			}

			empty {
				display: block;
				height: 40.5px;
			}

			.store-category.inputFrame {
				display: flex;
				flex-direction: column;
				gap: 10px;
			}
		}
	}
	:global(#createstore .createstore-composite label, #createstore
			.createstore-composite
			input, #createstore .createstore-composite button, #createstore
			.createstore-composite
			.storecategory
			span, #createstore .createstore-composite button span) {
		font-size: 1rem;
	}

	@include DesktopSize {
		main {
			.basicInfomation {
				.store-category.inputFrame {
					flex-direction: row;
				}
			}
		}
		:global(#createstore .createstore-composite label, #createstore
				.createstore-composite
				input, #createstore .createstore-composite button, #createstore
				.createstore-composite
				.storecategory
				span, #createstore .createstore-composite button span) {
			font-size: 1.125rem;
		}
	}
	/* address */

	main {
		#search-add-back {
			width: 32.8px;
			height: 30px;
			position: absolute;
			top: 10.6px;
			right: 10px;

			&:hover {
				cursor: pointer;
			}
		}
	}

	@include DesktopSize {
		main {
			#search-add-back {
				top: 20px;
				right: 20px;
			}
		}
	}

	/*  Registration */
	.button-input-frame {
		display: flex;
		gap: 10px;
		span.white {
			color: white;
		}
		.next {
			flex-grow: 150;
			span {
				font-weight: 500;
				font-size: 1.25rem;
				color: var(--default-disabled-btn-2);
				&.white {
					color: white;
				}
			}
		}
		.skip {
			flex-grow: 120;
			span {
				transition: color 0.15s;
				color: var(--default-nav);

				&.hover {
					color: var(--signature-blue);
				}
			}
		}
	}
	@include DesktopSize {
		.button-input-frame {
			gap: 30px;
			.skip {
				flex-basis: 140px;
				flex-grow: 0;
			}
		}
	}

	//term
	main {
		.term-button {
			color: var(--default-disabled-btn-2);
		}
	}

	//success
	main {
		.welcome-container {
			width: 100%;
			height: 100%;
			flex-grow: 1;
			display: flex;
			justify-content: center;
			align-items: center;

			.welcome-box {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: 100%;
				max-width: 400px;

				.welcome-message {
					font-weight: 500;
					font-size: 1.25rem;
					color: white;
					margin-top: 80.2px;
				}
			}
			.button-wrapper {
				width: 400px;
				max-width: 100%;
				box-sizing: border-box;
				padding: 0px 30px;
			}
			.description {
				margin-top: 20px;
				color: #bcbfc3;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 10px;
				span {
					font-size: 1rem;
				}
			}
			empty {
				display: block;
				height: 70.5px;
			}
			span.white {
				color: white;
				font-weight: 500;
				font-size: 1.25rem;
			}
		}
	}
	@include DesktopSize {
		main {
			.welcome-container {
				.welcome-box {
					max-width: 500px;

					:global(svg) {
						transform: scale(1.4);
					}
					.welcome-message {
						margin-top: 112.8px;
					}
				}
			}
		}
	}

</style>
